import React from 'react';

import FileItem from './FileItem';

import styles from './FilesList.scss';
import { UploaderFilesListProps } from './types';

function FilesList(props: UploaderFilesListProps) {
  const { files = [], onFilesChange } = props;

  return (
    <div data-test-id="file-list" className={styles.files}>
      {files.map((file) => (
        <FileItem
          fileName={file.name}
          key={file.id}
          onRemove={() => onFilesChange(files.filter((f) => f.id !== file.id))}
        />
      ))}
    </div>
  );
}

export default React.memo(FilesList);
